<template>
  <v-row dense :class="{ 'my-4': $vuetify.breakpoint.smAndDown }">
    <v-col
      v-for="(item, index) in items"
      :key="item.value"
      :cols="$vuetify.breakpoint.mobile ? 6 : 3"
    >
      <v-btn
        block
        large
        style="text-transform: none; width: 100%; border-radius: 8px; height: 40px !important;"
        :style="
          `border: 1px solid ${
            $vuetify.theme.themes.dark.primary
          } !important; background: ${
            index === casinoRange ? $vuetify.theme.themes.dark.primary : ''
          };`
        "
        @click="setCasinoRange(index)"
      >
        <span
          class="text-wrap"
          :style="
            item.value === 'customRange' && $vuetify.breakpoint.width < 400
              ? 'width: min-content; margin: auto;'
              : ''
          "
        >
          {{ item.text }}
        </span>
        <v-icon v-if="item.value === 'customRange'">
          mdi-chevron-down
        </v-icon>
      </v-btn>
    </v-col>

    <div
      v-if="casinoDateOption === 'customRange'"
      class="d-flex justify-end mt-2 px-1"
      :class="{
        'mb-2': $vuetify.breakpoint.mdAndUp,
      }"
      style="gap: 10px; width: 100%;"
    >
      <div
        class="d-flex"
        style="gap: 10px;"
        :style="$vuetify.breakpoint.mdAndUp ? 'width: 50%;' : 'width: 100%;'"
      >
        <v-menu
          v-model="fromMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-bind="attrs"
              v-on="on"
              :value="from && `${$t('from')} ${from}`"
              solo-inverted
              dense
              hide-details
              filled
              :placeholder="`${$t('from')} __/__/____`"
              readonly
              style="border-radius: 8px;"
            ></v-text-field>
          </template>

          <v-date-picker
            v-model="fromDate"
            @input="fromMenu = false"
            :allowed-dates="disableFutureDays"
            :month-format="formatMonth"
            :first-day-of-week="0"
            :locale="locale"
          ></v-date-picker>
        </v-menu>

        <v-menu
          v-model="toMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
          :nudge-left="115"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-bind="attrs"
              v-on="on"
              :value="to && `${$t('until')} ${to}`"
              dense
              solo-inverted
              hide-details
              filled
              readonly
              :placeholder="`${$t('until')} __/__/____`"
              style="border-radius: 8px;"
            ></v-text-field>
          </template>

          <v-date-picker
            v-model="toDate"
            @input="toMenu = false"
            :allowed-dates="disableFutureDays"
            :min="fromDate"
            :month-format="formatMonth"
            :first-day-of-week="0"
            :locale="locale"
          ></v-date-picker>
        </v-menu>
      </div>
    </div>
  </v-row>
</template>

<script>
export default {
  data: (vm) => ({
    items: [
      { text: vm.$t("casinoBetting.date.last24Hours"), value: "last24Hours" },
      { text: vm.$t("casinoBetting.date.last48Hours"), value: "last48Hours" },
      { text: vm.$t("casinoBetting.date.last7Days"), value: "last7Days" },
      {
        text: vm.$t("casinoBetting.date.dateInterval"),
        value: "customRange",
      },
    ],
    fromMenu: false,
    toMenu: false,
    fromDate: "",
    toDate: "",
  }),

  watch: {
    from(val) {
      if (!val) {
        this.fromDate = "";
      }
    },
    to(val) {
      if (!val) {
        this.fromDate = "";
      }
    },
    fromDate(val) {
      if (val) {
        const brazilianDate = new Date(val.split("-")).toLocaleDateString();
        this.$store.commit("setCasinoCustomRange", { from: brazilianDate });
      }
    },
    toDate(val) {
      if (val) {
        const brazilianDate = new Date(val.split("-")).toLocaleDateString();
        this.$store.commit("setCasinoCustomRange", { to: brazilianDate });
      }
    },
    casinoDateOption(val) {
      if (val !== "customRange") {
        this.toMenu = false;
        this.fromMenu = false;
      }
    },
  },

  computed: {
    casinoDateOption() {
      return this.$store.state.filters.casinoRange.value;
    },
    locale() {
      return window.navigator.language;
    },
    casinoRange() {
      return this.$store.state.filters.casinoRange.option;
    },
    from: {
      get() {
        return this.$store.state.filters.casinoRange.customRange.from;
      },
      set(val) {
        this.$store.commit("setCasinoCustomRange", { from: val });
      },
    },
    to: {
      get() {
        return this.$store.state.filters.casinoRange.customRange.to;
      },
      set(val) {
        this.$store.commit("setCasinoCustomRange", { to: val });
      },
    },
  },

  methods: {
    setCasinoRange(index) {
      this.$store.commit("setCasinoRange", {
        option: index,
        item: this.items[index],
      });
    },
    disableFutureDays(date) {
      const now = new Date();
      const monthDate = new Date(date);
      return now > monthDate;
    },
    formatMonth(date) {
      const monthIndex = date.substr(5, 6) - 1;
      return this.getMonthName(monthIndex);
    },
    getMonthName(monthIndex) {
      const month = new Date(2023, monthIndex, 1).toLocaleString("default", {
        month: "long",
      });
      return this.capitalize(month);
    },
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
};
</script>
